import { createAction } from 'redux-actions';

export default {
    SaveHistory: createAction('SAVE_HISTORY'),
    UpdateUserCfg: createAction('UPDATE_USER_CFG'),
};
